<template>
  <div>
    <section class="song-search hero is-primary">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <div class="field">
                <p
                  class="control has-icons-left has-icons-right"
                  :class="{ 'is-loading': false }"
                >
                  <input
                    v-model="filter"
                    class="input"
                    type="text"
                    placeholder="Search"
                    @keydown.esc.prevent="clearFilter()"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-search" />
                  </span>
                  <span class="icon is-small is-right clickable">
                    <a
                      v-if="filter"
                      class="delete"
                      href="#"
                      @click.prevent="clearFilter()"
                    />
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="song-list">
      <div class="table-container">
        <table class="table is-fullwidth">
          <thead  class="container">
            <tr class="content" v-if="teamSongs.length">
              <th>Name</th>
              <th>Quality</th>
              <th v-for="m in teamSongs[0].member_data" :key="m.user.id">{{ m.user.name.split(' ').map(e => e[0]).join('') }}</th>
            </tr>
          </thead>
          <tbody   class="container">
            <tr
              v-for="teamSong in teamSongs"
              :key="teamSong.id"
              class="content song"
              >
              <td @click="showTeamSong(teamSong)" style="text-transform: uppercase;">{{ teamSong.title }}</td>
              <td>
            <button
              :class="[
                'button',
                'is-inverted',
                (teamSong.quality || teamSong.properties.quality) === 2
                  ? 'is-success'
                  : (teamSong.quality || teamSong.properties.quality) === 1
                    ? 'is-info'
                    : 'is-danger'
              ]"
            disabled>
              <span class="icon is-small">
                <i :class="{
          fas: true,
                'quality-unknown fa-eye-slash': (teamSong.quality || teamSong.properties.quality || 0) === 0,
                'quality-need-review fa-eye': (teamSong.quality || teamSong.properties.quality) === 1,
                'quality-certified fa-award': (teamSong.quality || teamSong.properties.quality) === 2
                  }" />
              </span>
            </button>
              </td>
              <td v-for="m in teamSong.member_data" :key="m.user.id">
                <button
                  class="button is-hovered"
                  :class="{
                  'is-static': (m.knowledge || 0) === 0,
                  'is-danger': m.knowledge === 1,
                  'is-warning': m.knowledge === 2,
                  'is-success': m.knowledge === 3
                  }"
                  disabled>
                  <span class="icon is-small">
                    <i class="fas fa-guitar" />
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--<BaseRouterRoundButton :destination="addLink" />-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { debounce } from "lodash";
import { onBottom } from "src/services/infinite-loading";

export default {
  data() {
    return {
      addLink: "new-song"
    };
  },
  computed: {
    ...mapGetters({
      teamSongs: "teamSongs"
    }),
    filter: {
      get() {
        return this.$store.getters.teamSongsFilter;
      },
      set(value) {
        this.changeFilter(value).then(this.debouncedRefreshTeamSongs.bind(this));
      }
    }
  },
  mounted() {
    onBottom(() => {
      this.loadMoreTeamSongs();
    });
  },
  beforeDestroy() {
    window.onscroll = () => {};
  },
  methods: {
    setupQuery(filter) {
      const query = {};
      if (filter) {
        query.filter = filter;
      }
      this.$router.replace({ query });
    },
    showTeamSong(teamSong) {
      this.$router.push({ name: "song", params: { id: teamSong.id } });
    },
    changeFilter(value) {
      this.setupQuery(value);
      return this.changeTeamSongsFilter({ main: value, tags: [] });
    },
    clearFilter() {
      return this.changeFilter("").then(this.quickRefreshTeamSongs.bind(this));
    },
    quickRefreshTeamSongs() {
      return this.refreshTeamSongs().then(this.loadMoreTeamSongs());
    },
    debouncedRefreshTeamSongs: debounce(function() {
      return this.quickRefreshTeamSongs();
    }, 500),
    ...mapActions(["changeTeamSongsFilter", "refreshTeamSongs", "loadMoreTeamSongs"])
  }
};
</script>

<style lang="scss">
.song-search .hero-body {
  padding: 1.5rem;
}
.song {
  @include list-element($fa-var-music);
}
.add {
  @include action-button();
}
.control .icon.clickable {
  .delete {
    pointer-events: auto;
  }
}
</style>



// WEBPACK FOOTER //
// SongsTable.vue?43b956e3